/**
 * Canonical subtext + placeholder copy for the payment / contact / terms fields shared across the
 * booking form, invoice form, payment settings and booking settings (MP-10953).
 *
 * One source of truth so every "appears on" surface shows identical wording — the ticket calls for
 * the same subtext and placeholder wherever a field appears.
 */
export interface FieldCopy {
  /** Grey helper line shown under the field label. */
  subtext: string;
  /** Placeholder shown in the editor when the field is empty. */
  placeholder: string;
}

export const PAYMENT_FIELD_COPY = {
  paymentTerms: {
    subtext: 'How and when you want your customer to pay',
    placeholder: 'e.g. Payment due within 30 days of invoice date.'
  },
  paymentDetails: {
    subtext: 'Your bank or payment details, e.g. bank name, sort code, account number.',
    placeholder: 'e.g. Barclays Bank, Sort code: 20-00-00, Account No: 12345678'
  },
  contactDetails: {
    subtext: 'How you want your customer to contact you.',
    placeholder: 'e.g. Telephone: 07900 000 000'
  },
  termsAndConditions: {
    subtext: 'The small print of a booking',
    placeholder: 'e.g. cancellation conditions, refund policy etc.'
  }
} as const satisfies Record<string, FieldCopy>;
